import { queryOptions } from '@tanstack/react-query';
import {
  getOrgBySlugServerFn,
  listInvitationsServerFn,
  listMembersServerFn,
  listOrgsServerFn,
} from '@/server/functions/organization';

export const listOrgsQueryOptions = queryOptions({
  queryKey: ['auth-orgs'],
  queryFn: () => listOrgsServerFn(),
});

export const orgBySlugQueryOptions = (orgSlug: string) =>
  queryOptions({
    queryKey: ['auth-org', orgSlug],
    queryFn: () => getOrgBySlugServerFn({ data: { orgSlug } }),
  });

export const orgMembersQueryOptions = (orgId: string, orgSlug: string) =>
  queryOptions({
    queryKey: ['org-members', orgId],
    queryFn: () => listMembersServerFn({ data: { orgSlug } }),
  });

export const orgInvitationsQueryOptions = (orgId: string, orgSlug: string) =>
  queryOptions({
    queryKey: ['org-invitations', orgId],
    queryFn: () => listInvitationsServerFn({ data: { orgSlug } }),
  });
